import { render, staticRenderFns } from "./CapacityTutor.vue?vue&type=template&id=d98d9e8e&scoped=true"
import script from "./CapacityTutor.vue?vue&type=script&lang=js"
export * from "./CapacityTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98d9e8e",
  null
  
)

export default component.exports